import { get, post, fileDown } from "@/utils/request";
import apiMap from "@/config";

const riskApi = apiMap.riskApi


export const getMemberList = data =>
  post(`${riskApi}/risk/user/findUserByPage`, data);

export const changeStatus = data =>
  post(`${riskApi}/risk/userRisk/updateUserRiskState`, data);

export const changeBatchStatus = data =>
  post(`${riskApi}/risk/userRisk/updateUserStatusBatch`, data);

export const changeAlert = data =>
  post(`${riskApi}/risk/userRisk/updateUserAlertBatch`, data);

export const changeRemarkBatch = data =>
  post(`${riskApi}/risk/user/batchUpdateRemark`, data);

export const changeSelfRiskBatch = data =>
  post(`${riskApi}/risk/user/batchUpdateSelfRisk`, data);

export const changeDelaySettleBatch = data =>
  post(`${riskApi}/risk/user/batchUpdateDelaySettle`, data);

export const getAllRiskLevel = data =>
  post(`${riskApi}/risk/userRisk/getAllRiskLevel`, data);

export const getRiskLevel = data =>
  post(`${riskApi}/risk/user/findAllRiskLevel`, data);

export const getRiskUpdate = data =>
  post(`${riskApi}/risk/userRisk/updateRiskLevel`, data);

export const getLableList = data =>
  post(`${riskApi}/risk/user/findAllLabel`, data);

export const getLevelUpdate = data =>
  post(`${riskApi}/risk/user/updateRiskLevelBatch`, data);

export const getLableUpdate = data =>
  post(`${riskApi}/risk/user/updateRiskLabelBatch`, data);

export const updateOddsLevel = data =>
  post(`${riskApi}/risk/user/batchUpdateOddsLevel`, data);

export const updateMarginOddsLevel = data =>
  post(`${riskApi}/risk/user/batchUpdateMarginOddsLevel`, data);

export const batchUpdateUserBaseDelayed = data =>
  post(`${riskApi}/risk/user/batchUpdateUserBaseDelayed`, data);

export const getMemberDetails = data =>
  get(`${riskApi}/risk/user/queryUserById`, data);

export const getMemberUpdate = data =>
  post(`${riskApi}/risk/user/update`, data);

export const getExport = (data, fileName) =>
  fileDown(`${riskApi}/risk/exportExcel`, data, fileName);

export const getMerchat = data =>
  post(`${riskApi}/risk/channel/list`, data);

export const queryAgentNames = data =>
  post(`${riskApi}/risk/merchant/list`, data);

export const getHistoryList = data =>
  post(`${riskApi}/risk/riskLevel/findAllLog`, data);

export const batchUpdateUserLevel = data =>
  post(`${riskApi}/risk/user/batchUpdateUserLevel`, data);

export const getLevelList = data =>
  post(`${riskApi}/risk/account/level/listForSelect`, data);

export const getUserQueryRequest = data =>
  post(`${riskApi}/risk/userQueryRequest/list`, data);

export const setUserQueryCommon = data =>
  post(`${riskApi}/risk/userQueryRequest/addOrUpdateCommon`, data);

export const setUserQueryPersonal = data =>
  post(`${riskApi}/risk/userQueryRequest/addOrUpdatePersonal`, data);